import React from 'react';
import { Box, Container, Flex, Heading, Image, Link, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

interface PortalAuthShellProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export default function PortalAuthShell({ title, subtitle, children }: PortalAuthShellProps) {
  return (
    <Box
      minH="100vh"
      position="relative"
      overflow="hidden"
    >
      {/* Background image layer */}
      <Box
        position="absolute"
        inset={0}
        backgroundImage="url('/background/emilia-igartua-bZh01rUqcXU-unsplash.jpg')"
        backgroundSize="cover"
        backgroundPosition="center center"
        backgroundRepeat="no-repeat"
        zIndex={0}
      />

      {/* Dark gradient overlay for better contrast */}
      <Box
        position="absolute"
        inset={0}
        bgGradient="linear(to-r, rgba(0,0,0,0.65), rgba(0,0,0,0.35))"
        zIndex={0.5}
      />

      {/* Foreground content; keep mostly transparent so background is visible */}
      <Box
        position="relative"
        zIndex={1}
        minH="100vh"
        py={{ base: 10, md: 16 }}
        px={4}
        bg="transparent"
      >
      <Container maxW="6xl">
        <Flex
          direction={{ base: 'column', lg: 'row' }}
          align="stretch"
          gap={{ base: 8, lg: 12 }}
        >
          <Flex flex="1" align="center">
            <Stack spacing={5} maxW="xl">
              <Link as={RouterLink} to="/" width="fit-content">
                <Image
                  src="/logo/ME logo_Final_white.png"
                  alt="Mercurian Equity"
                  height={{ base: '30px', sm: '36px', md: '46px' }}
                  width="auto"
                  maxW={{ base: '150px', sm: '180px', md: '250px' }}
                  objectFit="contain"
                />
              </Link>
              <Heading size="2xl" color="white" lineHeight="1.1">
                {title}
              </Heading>
              <Text fontSize="lg" color="gray.100">
                {subtitle}
              </Text>
            </Stack>
          </Flex>

          <Box
            flex="1"
            bg="white"
            borderWidth="1px"
            borderColor="gray.200"
            borderRadius="2xl"
            boxShadow="0 20px 60px rgba(15, 23, 42, 0.08)"
            p={{ base: 6, md: 8 }}
          >
            {children}
          </Box>
        </Flex>
      </Container>
      </Box>
    </Box>
  );
}
